import { Button, Combobox, Field, Option } from "@fluentui/react-components";
import { useEffect, useState } from "react";
import i18n from "i18next";
import { fetchWrapper } from "../helpers/fetchwrapper";
import { baseUrl } from "../helpers/constants";
import { IUserDocument } from "../Models/IUserDocument";
import {
  DismissRegular,
  DocumentPdfRegular,
  DocumentRegular,
  VideoClipRegular,
} from "@fluentui/react-icons";

interface IAddAcademyDocumentDialogProps {
  setSelectedDocuments(selectedDocuments: IUserDocument[]): void;
  folderGuid: string;
  currentDocuments: string[] | undefined;
}
export default function DocumentPicker(props: IAddAcademyDocumentDialogProps) {
  const [searchValue, setSearchValue] = useState<string>("");

  const [selectedDocuments, setSelectedDocuments] = useState<IUserDocument[]>(
    [],
  );

  const [searchDocumentList, setSearchDocumentList] = useState<IUserDocument[]>(
    [],
  );

  const removeDocument = (docGuid: string) => {
    setSelectedDocuments(
      selectedDocuments.filter((x) => x.userObjectGuid != docGuid),
    );
  };

  const getAcademyDocuments = (filter: string) => {
    return fetchWrapper
      .getWithAuth(
        `${baseUrl}/api/academy/GetAcademyDocumentsByFilter?filter=${filter}`,
      )
      .then((data: IUserDocument[]) => {
        // Wir müssen die aktuell ausgewählten Dokumente aus dem Ergebnis herausfiltern.
        var list = data.filter(
          (x) =>
            !selectedDocuments.some(
              (y) => y.userObjectGuid == x.userObjectGuid,
            ),
        );
        if (props && props.currentDocuments) {
          list = list.filter(
            (x) =>
              !props?.currentDocuments?.some(
                (guid) => guid == x.userObjectGuid,
              ),
          );
        }

        setSearchDocumentList(list);
      });
  };

  useEffect(() => {
    if (selectedDocuments) {
      props.setSelectedDocuments(selectedDocuments);
    } else {
      props.setSelectedDocuments([]);
    }
  }, [selectedDocuments]);

  useEffect(() => {
    if (searchValue) {
      getAcademyDocuments(searchValue);
    } else {
      setSearchDocumentList([]);
    }
  }, [searchValue]);

  return (
    <div style={{ minHeight: "100px", marginTop: "7px" }}>
      <Field
        size="large"
        label={i18n.t<string>("suchen")}
        style={{ maxWidth: 400 }}
      >
        <Combobox
          value={searchValue}
          onChange={(val) => {
            setSearchValue(val.currentTarget.value);
          }}
        >
          {searchDocumentList.map((item) => {
            return (
              <Option
                onClick={() => {
                  var selectedDocumentsNew = [...selectedDocuments];
                  selectedDocumentsNew.push(item);
                  setSelectedDocuments(selectedDocumentsNew);
                  setSearchValue("");
                }}
                text="Katri Athokas"
              >
                {item.displayDocFileName}
              </Option>
            );
          })}
        </Combobox>
      </Field>
      <div style={{ minHeight: "100px" }}>
        {selectedDocuments.map((item) => {
          if (item.docFileExtension.toLocaleLowerCase() == "pdf") {
            return (
              <div
                style={{ alignItems: "center", display: "flex", margin: "2px" }}
              >
                <DocumentPdfRegular color="#d65532" fontSize={"24px"} />
                {item.displayDocFileName}
                <Button
                  onClick={() => {
                    removeDocument(item.userObjectGuid);
                  }}
                  appearance="transparent"
                  icon={<DismissRegular />}
                ></Button>
              </div>
            );
          } else if (item.docFileExtension.toLocaleLowerCase() == "mp4") {
            return (
              <div
                style={{ alignItems: "center", display: "flex", margin: "2px" }}
              >
                <VideoClipRegular color="#d65532" fontSize={"24px"} />
                {item.displayDocFileName}
                <Button
                  onClick={() => {
                    removeDocument(item.userObjectGuid);
                  }}
                  appearance="transparent"
                  icon={<DismissRegular />}
                ></Button>
              </div>
            );
          } else {
            return (
              <div
                style={{ alignItems: "center", display: "flex", margin: "2px" }}
              >
                <DocumentRegular fontSize={"24px"} />
                {item.displayDocFileName}
                <Button
                  onClick={() => {
                    removeDocument(item.userObjectGuid);
                  }}
                  appearance="transparent"
                  icon={<DismissRegular />}
                ></Button>
              </div>
            );
          }
        })}
      </div>
    </div>
  );
}
